import { render } from "./SaveMembership.vue?vue&type=template&id=17f4b9a2"
import script from "./SaveMembership.vue?vue&type=script&lang=js"
export * from "./SaveMembership.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__